export const msalConfig = {
  auth: {
    clientId: '48324420-a293-4e78-87c1-0c72ecf88f2f',
    authority: 'https://login.microsoftonline.com/4d79b588-0df5-4b16-a705-997e658084cd',
    redirectUri: 'https://sales.tudi.com/auth',
    postLogoutRedirectUri: 'https://sales.tudi.com/login',
  },
};
